import { cx } from '@emotion/css';
import type { FC, ReactNode } from 'react';

import { MotifComponent, useMotifStyles } from '../../motif';
import type { ImageSources } from '../../types';
import { ImageButton } from '../ImageButton';
import {
  authorCss,
  authorCssWithVisualTestimonyCss,
  quoteCss,
  quoteCssWithVisualTestimonyCss,
  quoteIconCss,
} from './Quote.styled';

interface Props {
  author?: ReactNode;
  children?: ReactNode;
  visualTestimony?: boolean; // True if the quote is used with a visual testimony
  imageSrc?: ImageSources;
}

export const Quote: FC<Props> = ({ author, children, visualTestimony = false, imageSrc }) => {
  useMotifStyles(MotifComponent.QUOTE);

  // Use left-aligned styles if the component is used with a visual testimony (video/image)
  // Figma design: https://docs.google.com/document/d/14b5gIKqyGZ2HmLMWMLYoEsSXUqSihN_76M_6M-1ZydQ/edit?tab=t.0
  const quoteStyles = visualTestimony ? quoteCssWithVisualTestimonyCss : quoteCss;
  const authorStyles = visualTestimony ? authorCssWithVisualTestimonyCss : authorCss;

  return (
    <div className={cx(MotifComponent.QUOTE, quoteStyles)}>
      <div className={quoteIconCss}>“</div>
      {children}

      {imageSrc && (
        <ImageButton height={128} width={128} imgSrcs={imageSrc} altText="Quote background" />
      )}

      {author && <div className={authorStyles}>{author}</div>}
    </div>
  );
};

Quote.displayName = 'Quote';
